// @flow
/* eslint-disable react/no-danger */
import React from 'react';
// import cn from 'classnames';
import moment from 'moment';
import Socialls from '../../Socialls';
import css from './ArticlePreview.scss';

type ImageInfo = {
	ID: number,
	Type: string,
	URL: string,
	Caption: string,
	Credit: string,
};

type Props = {
	title: string,
	description: string,
	imageInfo: ImageInfo | any,
	author: string,
	date: string,
};

export function ArticlePreview({ title, description, imageInfo, author, date }: Props) {
	const renderDate = () => {
		const formatedDate = moment(date).format('DD/MM/YYYY');
		const today = moment().subtract(0, 'days');
		const yesterday = moment().subtract(1, 'days');

		if (moment(formatedDate, 'DD/MM/YYYY').isSame(moment(today, 'DD/MM/YYYY'), 'day')) {
			return `${moment(date).format('HH:mm')}`;
		}
		if (moment(formatedDate, 'DD/MM/YYYY').isSame(moment(yesterday, 'DD/MM/YYYY'), 'day')) {
			return `אתמול ${moment(date).format('HH:mm')}`;
		}

		return formatedDate;
	};

	return (
		<div className={css.articlePreview}>
			<div className={css.articleInto}>
				<div className={css.articleIntoTop}>
					<h1 className={css.title} dangerouslySetInnerHTML={{ __html: title }} />
					<h4 className={css.description} dangerouslySetInnerHTML={{ __html: description }} />
				</div>
				<div className={css.articleIntoBottom}>
					<p className={css.author}>
						<span>{author}</span> | {renderDate()}
					</p>
					<Socialls />
				</div>
			</div>
			<div className={css.imagePreview}>
				{imageInfo.URL && <img src={imageInfo.URL} alt={imageInfo.Caption} />}
				<p>
					{imageInfo.Caption && imageInfo.Caption}
					{imageInfo.Credit && ` (${imageInfo.Credit})`}
				</p>
			</div>
		</div>
	);
}

ArticlePreview.propTypes = {};
